module.exports = __webpack_public_path__ + "img/erweima.26babe41.jpg";